import { saveFolderToDb } from "scripts/api/folder";
import { ApiError } from "scripts/api/errors";
import { openAuthModal } from "scripts/ui/auth/auth";
import { MessageToast } from "../components/toast";
import { folderDropdown } from "scripts/app";

export class FolderSavePopup {

    public modal: HTMLElement;
    public input: HTMLInputElement;
    public saveBtn: HTMLButtonElement;
    public cancleBtn: HTMLButtonElement;

    constructor() {
        const modal = document.getElementById('saveFolderModal');
        const input = document.getElementById('folderNameInput');
        const saveBtn = document.getElementById('confirmSaveFolderBtn');
        const cancleBtn = document.getElementById('cancelSaveFolderBtn');

        if (
            !(modal instanceof HTMLDivElement) ||
            !(input instanceof HTMLInputElement) ||
            !(saveBtn instanceof HTMLButtonElement) ||
            !(cancleBtn instanceof HTMLButtonElement)
        )
            throw new Error('Ошибка! Модальное окно сохранения папки не найдено!');

        this.modal = modal;
        this.input = input;
        this.saveBtn = saveBtn;
        this.cancleBtn = cancleBtn;

        this.addEventListener();
    }

    public openModal(){
        this.modal.style.display = 'block';
    }

    private addEventListener() {
        this.saveBtn.addEventListener('click', async () => { await this.saveFolder()});
        this.cancleBtn.addEventListener('click', () => {this.closeModal()});
    }


    /**
     * Сохранение папки
     * @returns 
     */
    private async saveFolder() {
        const folderName = this.input.value.trim();
        if (!folderName) {
            MessageToast.showDanger('2', 'Введите название папки');
            return;
        }

        try {
            const folder = await saveFolderToDb(folderName);
            MessageToast.show('2', `Папка ${folder.name} успешно создана`);
            this.input.value = '';
            folderDropdown.loadMenu();
            await folderDropdown.onSelect(folder);
            this.closeModal();
        } catch (err) {
            // 401/403 — сессия истекла: сервер больше не признаёт cookie.
            // Показываем понятную причину и предлагаем войти заново, а не
            // глухое «Ошибка создания новой папки».
            if (err instanceof ApiError && err.isAuth) {
                MessageToast.showDanger('2', 'Сессия истекла. Войдите в аккаунт заново.');
                this.closeModal();
                openAuthModal();
                return;
            }
            // Показываем причину с сервера (detail), если она есть; иначе —
            // чистый фолбэк без «кода N», который пользователю ничего не говорит.
            let msg = 'Не удалось создать папку';
            if (err instanceof ApiError && err.message && !err.message.startsWith('HTTP ')) {
                msg = err.message;
            }
            MessageToast.showDanger('2', msg);
            console.error('Создание папки не удалось', err);
        }
    }

    private closeModal(){
        this.input.value = '';
        this.modal.style.display = 'none';
    }

}